
export interface CurrentUser {
    fullName: string
    email: string
    initials: string
    permissionList: string[]
    monthsThreshold: number
}

export enum UserPermissions {
    ADD = "ADD",
    EDIT = "EDIT",
    VIEW = "VIEW"
}